import {
  GET_MOORING_LOCATIONS,
  CREATE_MOORING_LOCATION,
  EDIT_MOORING_LOCATION,
  DELETE_MOORING_LOCATION,
  MOORING_LOCATION_ERROR,
  SHOW_MOORING_LOCATION_LOADING,
  SHOW_EDIT_MOORING_LOCATION_LOADING,
} from '../actions/types';

/**
 * aldrine-facistol-sc-1165: Logbook - Add dropdown for 2 fields
 */

const initialState = {
  mooringLocationList: [],
  mooringLocationLoading: false,
  editMooringLocationLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MOORING_LOCATION_LOADING:
      return {
        ...state,
        mooringLocationLoading: true,
      };
    case SHOW_EDIT_MOORING_LOCATION_LOADING:
      return {
        ...state,
        editMooringLocationLoading: true,
      };
    case GET_MOORING_LOCATIONS:
      return {
        ...state,
        mooringLocationList: payload,
        mooringLocationLoading: false,
      };
    case CREATE_MOORING_LOCATION:
      return {
        ...state,
        mooringLocationList: [payload, ...state.mooringLocationList],
        editMooringLocationLoading: false,
        mooringLocationLoading: false,
      };
    case EDIT_MOORING_LOCATION:
      return {
        ...state,
        mooringLocationList: state.mooringLocationList.map((item) =>
          item._id === payload._id ? payload : item,
        ),
        editMooringLocationLoading: false,
        mooringLocationLoading: false,
      };
    case DELETE_MOORING_LOCATION:
      return {
        ...state,
        mooringLocationList: state.mooringLocationList.filter(
          (item) => item._id !== payload,
        ),
        editMooringLocationLoading: false,
        mooringLocationLoading: false,
      };
    case MOORING_LOCATION_ERROR:
      return {
        ...state,
        error: payload,
        mooringLocationLoading: false,
        editMooringLocationLoading: false,
      };
    default:
      return state;
  }
}
